<div class="hotel_skeleton" *ngIf="cardCount">
    <div *ngFor="let a of counter(cardCount); let index = index" class="hotel_card_skeleton seatcard">
        <span class="pointer top-label"><span></span></span>
        <div class="skeleton_row">
            <div class="logovslogo skeleton_col_1">
            </div>
            <div class="selectseat skeleton_col_2">
                <div class="title-line"></div>
                <div class="subtitle-line"></div>
                <div class="option_skeleton">
                    <div class="circle"></div>
                    <div class="line"></div>
                </div>
                <div class="button-boxes">
                    <div class="button-box"></div>
                    <div class="button-box"></div>
                </div>
            </div>
        </div>
    </div>
</div>